    <label [ngClass]="{'mr-3': true, 'slide-toggle__label--disabled': disabled}">
        {{ "OrderSection.IcastOrthoModel" | translate }}
    </label>

    <tlk-slide-toggle
        class="icast-ortho-model-toggle"
        [checked]="checked"
        (changeEvent)="onCheck($event)"
        name="isIcastOrthoModelSelected"
        [formControl]="control"
        [isDisabled]="disabled"
    >
    </tlk-slide-toggle>
